<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-left="0"
    transition="scale-transition"
    offset-y
    min-width="auto">
    <template v-slot:activator="{ attrs, on }">
      <H2 v-bind="attrs" v-on="on">
        {{ formatMonth(month) }}
        <v-icon class="-tw-mt-1" large>mdi-chevron-down</v-icon>
      </H2>
    </template>
    <v-date-picker
      v-model="month"
      color="#00A82D"
      class="tw-border-transparent"
      type="month"
      @change="updateValue()"
      locale="de"
      no-title />
  </v-menu>
</template>

<script>
import H2 from '@/components/Typography/H2.vue'
import { monthformatter } from './formatter'

export default {
  components: { H2 },
  props: ['value', 'headlineExtraClasses'],
  data: function () {
    return {
      menu: false,
      month: this.value.toISOString().substring(0, 7),
    }
  },
  methods: {
    updateValue: function () {
      this.$emit('input', new Date(this.month))
      this.menu = false
    },
    formatMonth: function (isostr) {
      const date = new Date(isostr)
      return monthformatter.format(date) + ' ' + date.getFullYear()
    },
  },
}
</script>
